<fieldset>
	<legend class="mb-3"><%= field.title %></legend>

	<% field.fields.forEach((field) => { %>
		<%- include(field.type, { form, field }) %>
	<% }); %>
</fieldset>
